import {z} from 'zod';

import {useLocation} from 'react-router-dom';

import {isEmpty} from 'ramda';

const emptyStringToUndefined = z.preprocess(
  (val) => (val === '' ? undefined : val),
  z.coerce.number().optional()
);

const VehicleQueryParamsSchema = z.object({
  vin: z.string().optional(),
  make: z.string().optional(),
  modelFamily: z.string().optional(),
  makeLabel: z.string().optional(),
  modelTitle: z.string().optional(),
  bodyStyle: z.string().optional(),
  engineVolume: emptyStringToUndefined,
  transmission: z.string().optional(),
  fuelType: z.string().optional(),
  modelYear: emptyStringToUndefined,
  firstRegistration: z.string().optional(),
  mileage: emptyStringToUndefined,
  lang: z.string().optional(),
});

export type VehicleQueryParams = z.infer<typeof VehicleQueryParamsSchema>;

interface UseVehicleQueryParamsResult {
  data: VehicleQueryParams | undefined;
  errors: z.ZodError | undefined;
}

export function useVehicleQueryParams(): UseVehicleQueryParamsResult {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const rawParams: Record<string, string> = Object.fromEntries(searchParams.entries());

  if (isEmpty(rawParams)) {
    return {data: undefined, errors: undefined};
  }

  const result = VehicleQueryParamsSchema.safeParse(rawParams);

  if (result.success) {
    return {data: result.data, errors: undefined};
  }

  return {data: undefined, errors: result.error};
}

export {VehicleQueryParamsSchema};
